var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsgShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 559 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14842_5015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 559,
    height: 232
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 559,
    height: 232,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14842_5015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.22 -115.648C460.61 -223.45 509.114 -292.801 632.36 -246.278C755.606 -199.754 868.69 92.8632 772.882 208.257C689.672 308.477 553.685 323.846 476.823 260.86C406.646 203.353 418.535 103.792 444.42 69.1073C470.304 34.4221 491.83 -7.84614 476.22 -115.648Z",
    fill: "#F4D4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.253 -101.389C483.634 -150.917 490.98 -296.318 639.52 -192.801C788.06 -89.2836 782.725 119.744 713.482 182.34C644.239 244.936 586.353 253.145 515.525 227.848C444.697 202.551 441.669 96.4864 478.351 60.8762C515.034 25.266 553.915 -55.8609 520.253 -101.389Z",
    fill: "#E1834E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.7445 331.508C-132.157 381.114 -125.189 500.673 -92.7823 526.248C62.8161 649.043 375.131 395.689 364.136 288.816C351.176 162.843 280.432 228.925 172.1 136.902C104.584 79.5492 24.0947 179.645 16.5302 217.478C8.96576 255.31 20.6678 281.903 -55.7445 331.508Z",
    fill: "#E4F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.967 357.372C-64.419 411.46 -50.6761 464.679 -26.4742 490.92C36.0747 558.741 287.823 405.591 284.739 316.004C283.057 267.136 234.002 216.135 175.016 184.261C116.029 152.387 39.3139 193.69 37.5725 239.232C35.831 284.774 -16.176 316.409 -36.967 357.372Z",
    fill: "#B4DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4221 -27.2421C6.56067 -52.4999 12.7199 -148.644 20.6657 -204.867C39.0975 -335.288 368.835 -315.952 408.663 -247.359C455.214 -167.189 374.339 -168.051 367.716 -7.27876C362.962 108.105 242.632 115.797 181.039 79.5873C119.446 43.3778 146.283 -1.98425 76.4221 -27.2421Z",
    fill: "#F8EEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4884 -66.7516C22.7204 -108.104 59.8027 -203.288 92.9556 -233.158C151.776 -286.153 258.635 -292.221 290.996 -257.275C341.346 -202.904 351.827 -118.375 331.942 -33.0935C312.058 52.1875 205.575 72.1959 167.073 22.1403C128.57 -27.9154 83.8202 -35.4334 57.4884 -66.7516Z",
    fill: "#EBCD63"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgShapes);
export default __webpack_public_path__ + "static/media/msg-shapes.0575d641.svg";
export { ForwardRef as ReactComponent };